import { BASE_URL } from "../config/BaseUrls";

const normalizeDir = (dir = "") =>
  dir.replace(/^\//, "").replace(/\/$/, "");

export const ensureHttps = (url = "") => {
  if (!url) return "";
  if (url.startsWith("https://")) return url;
  if (url.startsWith("//")) return `https:${url}`;
  if (url.startsWith("http://")) return `https://${url.slice(7)}`;
  return url;
};

const isAbsolute = (value) =>
  /^(data:|https?:|\/\/)/i.test(value);

export const resolveImageUrl = (
  raw = "",
  { baseUrl = BASE_URL, fallbackUrl = "", defaultDir = "" } = {}
) => {
  const trimmed = typeof raw === "string" ? raw.trim() : "";

  if (!trimmed) return fallbackUrl;
  if (isAbsolute(trimmed)) {
    return ensureHttps(trimmed);
  }

  if (trimmed.startsWith("/")) {
    return ensureHttps(`${baseUrl}${trimmed}`);
  }

  if (defaultDir) {
    const dir = normalizeDir(defaultDir);
    return ensureHttps(
      `${baseUrl}/${dir}/${trimmed.replace(/^\/+/, "")}`
    );
  }

  return ensureHttps(
    `${baseUrl}/${trimmed.replace(/^\/+/, "")}`
  );
};

/**
 * Resolves book image URL with specific handling:
 * - If image contains http/https, use it as is (ensuring https)
 * - If image contains "/uploads" (including "/uploadsbook"), use BASE_URL + path as-is
 * - If no http/https and no "/uploads", use BASE_URL/uploadsbook/{image}
 * - Always ensures HTTPS
 */
export const resolveBookImageUrl = (image = "") => {
  if (!image || typeof image !== "string") return "";
  
  const trimmed = image.trim();
  if (!trimmed) return "";

  // Check if image already contains http or https
  if (trimmed.startsWith("http://") || trimmed.startsWith("https://")) {
    // Ensure it's https
    return ensureHttps(trimmed);
  }

  // Check if image already contains "/uploads" (could be "/uploads/" or "/uploadsbook/")
  if (trimmed.includes("/uploads")) {
    // Path already contains uploads or uploadsbook, use it as-is with BASE_URL
    const cleanPath = trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
    return ensureHttps(`${BASE_URL}${cleanPath}`);
  }

  // If no http/https and no "/uploads", use BASE_URL/uploadsbook/{image}
  // Remove leading slash if present
  const cleanImage = trimmed.replace(/^\/+/, "");
  return ensureHttps(`${BASE_URL}/uploadsbook/${cleanImage}`);
};

